import { render } from "./StudyCenter.vue?vue&type=template&id=aa3ec106"
import script from "./StudyCenter.vue?vue&type=script&lang=js"
export * from "./StudyCenter.vue?vue&type=script&lang=js"

import "./StudyCenter.vue?vue&type=style&index=0&id=aa3ec106&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__